<template>
    <div class="pb-10">
        <slot name="header" />
        <template
            v-for="(vehicle, vIndex) in items"
            :key="vIndex">
            <vehicle-item
                :vehicle="vehicle"
                :info-type="filters?.infoType"
                :active="isActive(vehicle)"
                @click="handleSelect(vehicle)">
                <span>
                    {{ vehicle }}
                </span>
            </vehicle-item>
        </template>
    </div>
</template>

<script setup lang="ts">
import VehicleItem from './vehicle-item.vue'
const props = defineProps({
  items: {
    type: Array as PropType<any[]>,
    required: true
  },
  filters: {
    type: Object
  }
})
const emits = defineEmits(['selected'])
const selectedId = ref<any>(null)
const isActive = (vehicle: any) => {
  if (!vehicle || !vehicle._id) {
    return false
  }
  return selectedId.value === vehicle._id
}
const handleSelect = (vehicle: any) => {
  if (!vehicle || !vehicle._id) {
    return
  }
  if (selectedId.value === vehicle._id) {
    selectedId.value = null
    emits('selected', null)
  } else {
    selectedId.value = vehicle._id
    emits('selected', vehicle)
  }
}
</script>
